// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import TextareaAutosize from '@fulcrumapp/react-textarea-autosize';
import cx from 'classnames';
import ElementView from './base/element-view';
import TextElementView from './text-element-view';
import ElementValueLabel from './base/element-value-label';

export default class HyperlinkElementView extends ElementView {
  static propTypes = {
    ...ElementView.propTypes,
    onHyperlinkClick: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      textValue: props.value.textValue || '',
    };
  }

  renderEditable() {
    const textElementStyles = TextElementView.styles;
    const { styles } = HyperlinkElementView;

    return (
      <div className={css(styles.valueContainer)}>
        <div className={css(styles.linkContainer)}>
          {this.renderLink()}
        </div>

        {!this.props.element.isDisabled
          && (
            <TextareaAutosize
              useCacheForDOMMeasurements
              disabled={this.props.disabled}
              minRows={1}
              value={this.state.textValue}
              onChange={this.handleChange}
              placeholder="Enter a URL"
              className={css(textElementStyles.default)}
            />
          )}
      </div>
    );
  }

  renderViewOnly() {
    const { styles } = ElementValueLabel;

    return (
      <div className={css(styles.label)}>
        {this.renderLink()}
      </div>
    );
  }

  renderLink() {
    let url = '#';

    if (this.props.value.isEmpty && this.props.element.defaultURL) {
      url = this.props.element.defaultURL;
    } else if (!this.props.value.isEmpty) {
      url = this.props.value.textValue;
    }

    const label = url === '#' ? this.props.element.label : url;

    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={this.handleLinkClick}
      >
        {label}
      </a>
    );
  }

  handleLinkClick = (event) => {
    if (event.target.getAttribute('href') === '#') {
      event.preventDefault();
    }

    this.props.onHyperlinkClick(this.props.value);
  };

  handleChange = (event) => {
    const textValue = event.target.value;

    this.setState({ textValue });

    this.props.value.textValue = textValue;

    this.props.onChange(this.props.value);
  };
}

const styles = cssInJS({
  valueContainer: {
    paddingTop: 10,
  },

  linkContainer: {
    paddingLeft: 5,
  },
});

HyperlinkElementView.styles = styles;
